import React from 'react';
import Media from '../components/Media';

const MediaPage = () => {
  return <Media />;
};

export default MediaPage;

